// src/modules/expert/member/routes.ts
import type { RouteRecordRaw } from 'vue-router'

export const memberRoutes: RouteRecordRaw[] = [
  {
    path: ':id/members',
    name: 'members-list',
    component: () => import('./views/Member.vue'),
    meta: { requiredPermission: 'MEMBER_READ' },
  },
  {
    path: ':id/edit-members-permission/:memberId/:memberName',
    name: 'edit-members-permission',
    component: () => import('./views/MemberPermissionEditor.vue'),
    meta: { requiredPermission: ['MEMBER_PERMISSIONS'] },
    props: true,
  },
  {
    path: ':id/roles',
    name: 'roles-list',
    component: () => import('./views/Roles.vue'),
    meta: { requiredPermission: ['MEMBER_READ'] },
  },
  {
    path: ':id/invites',
    name: 'invites-list',
    component: () => import('./views/Invites.vue'),
    meta: { requiredPermission: ['MEMBER_READ'] },
  },
  {
    path: ':id/invites/:inviteId/permissions',
    name: 'edit-invite-permissions',
    component: () => import('./views/InvitePermissionsEditor.vue'),
    meta: { requiredPermission: ['MEMBER_PERMISSIONS'] },
    props: true,
  },
  {
    path: ':id/new-role',
    name: 'new-role',
    component: () => import('./views/NewRole.vue'),
    meta: { requiredPermission: ['MEMBER_PERMISSIONS'] },
  },
  {
    path: ':id/edit-role/:roleId',
    name: 'edit-role',
    component: () => import('./views/RoleDetail.vue'),
    meta: { requiredPermission: ['MEMBER_PERMISSIONS'] },
    props: true,
  },
  {
    path: ':id/filter-members',
    name: 'filter-members',
    component: () => import('./views/FilterMembers.vue'),
  },
  {
    path: ':id/filter-invites',
    name: 'filter-invites',
    component: () => import('./views/FilterInvites.vue'),
    meta: { requiredPermission: ['MEMBER_INVITE'] },
  },
]
